import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/input
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InputCommand from "./inputcommand";
import injectUnsafeKeystrokesHandling from "./utils/injectunsafekeystrokeshandling";
import injectTypingMutationsHandling from "./utils/injecttypingmutationshandling";
/**
 * Handles text input coming from the keyboard or other input methods.
 *
 * @extends module:core/plugin~Plugin
 */

var Input = /*#__PURE__*/function (_Plugin) {
  _inherits(Input, _Plugin);

  var _super = _createSuper(Input);

  function Input() {
    _classCallCheck(this, Input);

    return _super.apply(this, arguments);
  }

  _createClass(Input, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor; // TODO The above default configuration value should be defined using editor.config.define() once it's fixed.

      var inputCommand = new InputCommand(editor, editor.config.get('typing.undoStep') || 20);
      editor.commands.add('input', inputCommand);
      injectUnsafeKeystrokesHandling(editor);
      injectTypingMutationsHandling(editor);
    }
    /**
     * Checks batch if it is a result of user input - e.g. typing.
     *
     *		const input = editor.plugins.get( 'Input' );
     *
     *		editor.model.document.on( 'change:data', ( evt, batch ) => {
     *			if ( input.isTyping( batch ) ) {
     *				console.log( 'The user typed something...' );
     *			}
     *		} );
     *
     * **Note:** This method checks if the batch was created using {@link module:typing/inputcommand~InputCommand 'input'}
     * command as typing changes coming from user input are inserted to the document using that command.
     *
     * @param {module:engine/model/batch~Batch} batch A batch to check.
     * @returns {Boolean}
     */

  }, {
    key: "isInput",
    value: function isInput(batch) {
      var inputCommand = this.editor.commands.get('input');
      return inputCommand._batches.has(batch);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Input';
    }
  }]);

  return Input;
}(Plugin);

export { Input as default };